/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work out the tip and split the bill. Enter the bill amount, the tip percentage and how many people are sharing.`)
};

const es_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la propina y reparte la cuenta. Introduce el importe de la cuenta, el porcentaje de propina y cuántas personas la comparten.`)
};

const de_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne das Trinkgeld und teile die Rechnung auf. Gib den Rechnungsbetrag, den Trinkgeld-Prozentsatz und die Anzahl der Personen ein.`)
};

const nl_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de fooi en verdeel de rekening. Vul het rekeningbedrag, het fooipercentage en het aantal personen in dat meebetaalt.`)
};

const fr_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez le pourboire et partagez l'addition. Entrez le montant de l'addition, le pourcentage de pourboire et le nombre de personnes qui partagent.`)
};

const it_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la mancia e dividi il conto. Inserisci l'importo del conto, la percentuale di mancia e in quante persone lo condividete.`)
};

const pt_br2_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a gorjeta e divida a conta. Insira o valor da conta, a porcentagem da gorjeta e quantas pessoas estão dividindo.`)
};

const pt_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a gorjeta e divida a conta. Insira o valor da conta, a percentagem de gorjeta e quantas pessoas vão partilhar.`)
};

const ja_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チップを計算し、会計を割り勘。会計額、チップの割合、人数を入力してください。`)
};

const zh_pct_tip_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算小费并分摊账单。输入账单金额、小费比例以及分摊人数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_intro", locale)
	if (locale === "en") return en_pct_tip_intro(inputs)
	if (locale === "es") return es_pct_tip_intro(inputs)
	if (locale === "de") return de_pct_tip_intro(inputs)
	if (locale === "nl") return nl_pct_tip_intro(inputs)
	if (locale === "fr") return fr_pct_tip_intro(inputs)
	if (locale === "it") return it_pct_tip_intro(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_intro(inputs)
	if (locale === "pt") return pt_pct_tip_intro(inputs)
	if (locale === "ja") return ja_pct_tip_intro(inputs)
	return zh_pct_tip_intro(inputs)
};